export default step => {
    switch (step) {
        case 0:
            return "credentials";
        default:
            return "register";
    }
};
